import React, { useEffect, useState } from 'react';
import useWordle from '../hooks/useWordle';
import Grid from './Grid';
import Keypad from './Keypad';
import Modal from './Modal';

export default function Wordle({ solution, handleRestart }) {
    const { currentGuess, handleKeyup, guesses, isCorrect, turn, usedKeys } = useWordle(solution);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        window.addEventListener('keyup', handleKeyup);

        if (isCorrect) {
            setTimeout(() => { setShowModal(true); }, 2000);
            window.removeEventListener('keyup', handleKeyup);
        }
        if (turn > 5) {
            setTimeout(() => { setShowModal(true); }, 2000);
            window.removeEventListener('keyup', handleKeyup);
        }

        return () => window.removeEventListener('keyup', handleKeyup);
    }, [handleKeyup, isCorrect, turn]);

    const handleClick = (key) => {
        handleKeyup({ key });
    };

    return (
        <div>
            <div>solution: {solution}</div>
            <div>currentGuess: {currentGuess}</div>
            <Grid guesses={guesses} currentGuess={currentGuess} turn={turn} />
            <Keypad usedKeys={usedKeys} handleClick={handleClick} />
            {showModal && <Modal isCorrect={isCorrect} turn={turn} solution={solution} handleRestart={handleRestart} />}
        </div>);
}